import { useI18n } from "@core/i18n/i18n";
import { computeDiffInDays, now, ONE_MONTH_IN_DAYS } from "@utils/date-utils";
import { Dayjs } from "dayjs";
import { useCallback } from "react";

interface UsePatientListingItemHook {
	getFormattedLastSessionDate: (date: Dayjs) => string;
}

export const usePatientListingItem = (): UsePatientListingItemHook => {
	const { formatDateRelative, formatDateMed } = useI18n();

	const getFormattedLastSessionDate = useCallback(
		(date: Dayjs) => {
			if (computeDiffInDays(date, now()) < ONE_MONTH_IN_DAYS) {
				return formatDateRelative(date);
			} else {
				return formatDateMed(date);
			}
		},
		[formatDateRelative, formatDateMed],
	);

	return { getFormattedLastSessionDate };
};
